import React from "react";
import DialogComponent from "../Dialog/Dialog";
import { Card } from "./CardContainer";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

import './Card.scss';

interface CardProp {
	card: Card,
	isSelected: boolean;
	valueSelected(response?: any): void;
}

const CardView: React.FC<CardProp> = ({ card, isSelected, valueSelected }): JSX.Element => {
	const [open, setOpen] = React.useState(false);
	const valueClicked = (index: number) => {
		valueSelected(index);
	};

	const handleClickOpen = () => {
		setOpen(true);
	};

	const handleClose = (): void => {
		setOpen(false);
	};
	return (
		<>
			<div className={isSelected ? (`card selected`) : (`card`)} onClick={(e) => valueClicked(card.index)}>
				<img
					className="main-image"
					src={card.imageUrl}
					alt={card.title}
				/>
				<div className='text-content'>
					<div className="title">{card.title}</div>
					<div className="body">{card.body}</div>
				</div>
				{(card.extendedBody) ? (<InfoOutlinedIcon className="moreInfo" onClick={handleClickOpen}></InfoOutlinedIcon>) : ([])

				}

			</div>

			{(card.extendedBody) ? (
				<DialogComponent open={open} onClose={handleClose}>
					<img
						className="dialog-image"
						src={card.imageUrl}
						alt={card.title}
					/>
					<div className="dialog-title">{card.title}</div>
					<div className="dialog-body" dangerouslySetInnerHTML={{ __html: card.extendedBody }}></div>
				</DialogComponent>) : ([])
			}
		</>
	);
};

export default CardView;
